
























































































import {Component} from 'vue-property-decorator';
import {Getter} from "vuex-class";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import {ModerationTemplateItem} from "@/store/user_management/template_moderation/types";
import ModerationTemplatesFilter from "@/components/UserManagement/ModerationTemplates/ModerationTemplatesFilter.vue";
import {DateTime} from "luxon";
import {ScrollButton} from "wings-ui-components";

@Component({
  components:{
    ModerationTemplatesFilter,
    ScrollButton
  },
  filters: {
    date(value: string) {
      if (!value) return;
      return DateTime.fromISO(value).toFormat('dd.LL.yyyy HH:mm:ss')
    }
  }})
export default class ModerationTemplates extends BaseItemsPage<ModerationTemplateItem>{
  @Getter("moderationTemplates") moderationTemplatesResponse: any;
  private is_show_filter = false;
  currentSort= "name";
  currentSortOrder= "desc";
  tableFields = [
    'create_date',
    'edit_date',
    'partner',
    'channel',
    'name',
    'description',
    'status'
  ];

  getData(): any {
    return this.moderationTemplatesResponse;
  }
}
